import { getTriAppConfig } from "../../TriAppConfig";

const CURRENT_USER_URL = "/p/webapi/current-user";
const SIGNON_URL = "/p/websignon/signon";
const SIGNOUT_URL = "/p/websignon/signout";
const SIGNOUT_SSO_URL = "/p/websignon/sso/signout";
const TRIRIGA_LOGIN_PAGE_URL = "/p/websignon";
const TRIRIGA_LOGIN_PAGE_REDIRECT_PARAM = "redirectUrl";

let currentUser = null;

async function getCurrentUser() {
  if (currentUser != null) {
    return currentUser;
  }
  const { tririgaUrl } = getTriAppConfig();
  const requestOptions = {
    method: "GET",
    cache: "no-cache",
    credentials: "include",
  };
  const userRequest = new Request(
    `${tririgaUrl}${CURRENT_USER_URL}`,
    requestOptions
  );
  let userResponse = null;
  try {
    userResponse = await fetch(userRequest);
  } catch (error) {
    throwCurrentUserError(null, error);
  }
  if (userResponse.ok) {
    currentUser = await userResponse.json();
    return currentUser;
  }
  throwCurrentUserError(userResponse.status);
}

function throwCurrentUserError(responseCode, error) {
  if (!responseCode) throw new Error({ errorType: "request-failed" });
  switch (responseCode) {
    case 401:
      throw new Error({ errorType: "unauthorized" });

    default:
      throw new Error({ errorType: "request-failed" });
  }
}

async function login(username, password, forceLogin = false) {
  const { tririgaUrl } = getTriAppConfig();

  const loginOptions = {
    method: "POST",
    body: JSON.stringify({
      userName: username,
      password: password,
      normal: !forceLogin,
      api: false,
    }),
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };
  const loginRequest = new Request(`${tririgaUrl}${SIGNON_URL}`, loginOptions);
  let loginResponse = null;
  try {
    loginResponse = await fetch(loginRequest);
  } catch (error) {
    throwLoginError(null, error);
  }
  if (loginResponse.ok) return { successful: true, loginResponse };
  throwLoginError(loginResponse.status);
}

function throwLoginError(responseCode, error) {
  if (!responseCode) throw new Error({ errorType: "login-failed" });
  switch (responseCode) {
    case 401:
      throw new Error({ errorType: "unauthorized" });

    case 403:
      throw new Error({ errorType: "already-logged" });

    default:
      throw new Error({ errorType: "request-failed" });
  }
}

async function logout(ssoLogOutRedirect = true) {
  const { sso, tririgaUrl } = getTriAppConfig();
  if (sso && ssoLogOutRedirect) {
    window.location.href = `${tririgaUrl}${SIGNOUT_SSO_URL}`;
  } else {
    const requestOptions = {
      method: "POST",
      cache: "no-cache",
      credentials: "include",
    };
    const logoutRequest = new Request(
      `${tririgaUrl}${sso ? SIGNOUT_SSO_URL : SIGNOUT_URL}`,
      requestOptions
    );
    const logoutResponse = await fetch(logoutRequest);
    return logoutResponse.ok;
  }
}

function redirectToTririgaLogin(redirectUrl) {
  const { tririgaUrl } = getTriAppConfig();
  window.location.href = `${tririgaUrl}${TRIRIGA_LOGIN_PAGE_URL}?${TRIRIGA_LOGIN_PAGE_REDIRECT_PARAM}=${redirectUrl}`;
}

export default {
  getCurrentUser,
  login,
  logout,
  redirectToTririgaLogin,
};
